import { render, staticRenderFns } from "./NoticePage.vue?vue&type=template&id=2e70eeea&scoped=true&"
import script from "./NoticePage.vue?vue&type=script&lang=js&"
export * from "./NoticePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e70eeea",
  null
  
)

export default component.exports